import { mdiChat, mdiEye } from '@mdi/js';
import Icon from '@components/icon/Icon';
import NewTooltip from '@components/tooltip/NewTooltip';
import { useModal } from '@stores';
import AdditionalInfoRequestModal from '../additional-info-request/AdditionalInfoRequestModal';
import { AdditionalInfoFilterStatuses, UserPermissions } from '@utils/enums';
import './additionalInfoActions.scss';
import { queryClient } from '@api/queryClient';
import { ADDITIONAL_INFO_QUERY_KEYS } from '@api/services/additional-info';
import { FILE_STORAGE_QUERY_KEYS } from '@api/services/file-storage';

const AdditionalInfoActions = ({ row }) => {
  const { openModal } = useModal();
  const isRequestOpen = row?.original?.status?.toLowerCase() === AdditionalInfoFilterStatuses.Open.toLowerCase();
  const isPermissionReadOnly = row?.original?.permission?.toLowerCase() === UserPermissions.ReadOnly.toLowerCase();

  const handleRespondClick = () => {
    queryClient.invalidateQueries({
      queryKey: [
        ADDITIONAL_INFO_QUERY_KEYS.GET_ADDITIONAL_INFO_FULL,
        row?.original?.ormAdditionalInfoActionID,
        row?.original?.requestID,
        row?.original?.version,
      ],
    });
    queryClient.invalidateQueries({
      queryKey: [FILE_STORAGE_QUERY_KEYS.GET_USER_FILE_DETAILS, row?.original?.ormAdditionalInfoActionID],
    });
    openModal(AdditionalInfoRequestModal, {
      canRespond: isRequestOpen,
      ormAdditionalInfoActionID: row?.original?.ormAdditionalInfoActionID,
      requestID: row?.original?.requestID,
      version: row?.original?.version,
    });
  };

  return (
    <div className='button-container'>
      {(!isRequestOpen || isPermissionReadOnly) && (
        <NewTooltip label='View Additional Information Request' className='view-notice' onClick={handleRespondClick}>
          <Icon focusable={false} path={mdiEye} size='16px' />
        </NewTooltip>
      )}
      {isRequestOpen && !isPermissionReadOnly && (
        <NewTooltip
          label='Respond to Additional Information Request'
          className='submit-comments'
          onClick={handleRespondClick}
        >
          <Icon focusable={false} path={mdiChat} size='16px' />
        </NewTooltip>
      )}
    </div>
  );
};

export default AdditionalInfoActions;
